import { createSlice } from "@reduxjs/toolkit";

const changePageSlice = createSlice({
  name: "changePage",
  initialState: {
    currentPage: 1,
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
});

export const { setCurrentPage } = changePageSlice.actions;
export default changePageSlice.reducer;
